export default __webpack_public_path__ + "static/media/fi_archive_rejected.47d6a433.svg";